
import React from "react";
import {FormControl, InputGroup} from "react-bootstrap";
import {Footnote} from "./FormScreenStyles";

const fontStyle = {
    fontFamily: 'Arial',

    fontStyle: 'normal',
    fontStretch: 'normal',
    lineWeight: 'normal',
    letterSpacing: 'normal',
    color: '#78848f',
    // width: 220,
    height: 44,
    border: 'solid 2px #ecf0f1',
}

const fontStyleMobileOnly = {
  fontSize: 16,
}
const fontStyleDesktopOnly = {
  fontSize: 14,
}


const LabelInput = (props: any) => {
    const formProps = {
        value: props.value !== undefined ? props.value : undefined,
        isInvalid: props.isInvalid !== undefined ? props.isInvalid : undefined,
        disabled: props.disabled !== undefined ? props.disabled : undefined,
        readOnly: props.readOnly !== undefined ? props.readOnly : undefined,
    }
    return (props.isMobile ?
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', ...(props.style || {})}}>
            <InputGroup.Text style={{ borderWidth: 0, minWidth: 99, height: 44, backgroundColor: '#ecf0f1' }}>
                <Footnote>{props.label}</Footnote>
            </InputGroup.Text>
            <FormControl
                style={{ flex: 1, ...fontStyle, ...fontStyleMobileOnly, ...(formProps.isInvalid ? { borderColor: 'red' } : {})}}
                placeholder={props.placeholder}
                onChange={(event: any) => props.handleOnChange(event.target.value)}
                {...formProps}
            />
        </div>
        : <>
            <InputGroup.Prepend style={{ display: 'flex', width: '100%', ...(props.style || {})}}>
                <div style={{ borderWidth: 0, minWidth: 99, height: 44, backgroundColor: '#ecf0f1', display: 'flex', alignItems: 'center', paddingLeft: 12 }}>
                    <Footnote>{props.label}</Footnote>
                </div>
                <FormControl
                    style={{ flex: 1, borderRadius: 0, ...fontStyle, ...fontStyleMobileOnly, ...(formProps.isInvalid ? { borderColor: 'red' } : {})}}
                    placeholder={props.placeholder}
                    onChange={(event: any) => props.handleOnChange(event.target.value)}
                    maxLength={props.maxLength}
                    {...formProps}
                />
            </InputGroup.Prepend>
        </>
    );
}

export default LabelInput;
